var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ReadyAnswerSearch'),_c('ReadyAnswerItem',{attrs:{"readyAnswer":{}}}),_vm._l((_vm._readyAnswers),function(readyAnswer){return _c('ReadyAnswerItem',{key:readyAnswer._id,attrs:{"readyAnswer":readyAnswer}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }